//
//
//
//
//
//
//

export default {
  name: "CaseImg",
  props: {
    largePic: {
      type: String,
    },
    smallPic: {
      type: String,
    },
  },
};
